import { useContext } from 'react'
import { analyticsContext } from 'src/contexts/Analytics'

const useAnalytics = () => useContext(analyticsContext)

export default useAnalytics
